import { Link } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { useQuery, useSearch, useSearchContext } from "@sajari/react-hooks";

const OfferCard = (props:any) => {
  const history = useHistory();
  const { query, setQuery } = useQuery();
  const { results = [] } = useSearch();
  const { searched } = useSearchContext();
  const offerCardItems = props.offerItems;

  const handleCategoryChange = (categoryName: string) => {
    setQuery(categoryName)
    history.push({
      pathname: '/search-results',
      search:`?${"q"}=${categoryName}`, 
      state: {
        searched: searched,
        results: results
      }
    });
  }

  return (
    <div className="offer-card">
      <div className="card-heading d-flex justify-content-between align-items-center">
        {/* <h4 className="heading-border">Clothing Shop</h4> */}
        <div className="heading-cta">
          {/* <Link>
            <i className="fas fa-angle-right"></i>
          </Link> */}
        </div>
      </div>
      <div className="shop-card-wrap">
        {offerCardItems && offerCardItems.map((item: any, index: number) => (
          <div key={index} className="shop-card"
            onClick={() => handleCategoryChange(item.productName)}>
            <div className="exclusive-product-card">
              <img alt='exclusive-product-img' src={item.src} loading="lazy" />
            </div>
          </div>
        ))}
      </div>
      {/* <div className="shop-now-btn">
        <Link>
          Shop now
        </Link>
      </div> */}
    </div>
  );
}

export default OfferCard;
